// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"50e54d88","475":"92886392","578":"b5918c44"}[chunkId] + ".chunk.css";
};